/**
 * Melding na omzetten. De API laat Exact en de orderbevestiging elkaar niet tegenhouden, dus de
 * bestelling kan er staan terwijl een van die twee mislukte — dat moet je dan wel zien, met waar
 * je het herstelt (de orderlijst: "Naar Exact versturen" / "Bevestiging sturen").
 */
export const notifyConverted = (messageApi, t, result) => {
  messageApi.success(t("quote.convert.done", { order: result.orderId }), 6);
  if (!result.savedToExact) messageApi.warning(t("quote.convert.exact_failed", { order: result.orderId }), 12);
  if (!result.confirmationSent) {
    messageApi.warning(t("quote.convert.confirmation_failed", { order: result.orderId }), 12);
  }
};
